import React from 'react';
import { EventsGridGallery } from 'src/modules/events/components/EventsGridGallery';
import { usePastLocalEventsListQuery } from 'src/modules/events/hooks/usePastLocalEventsListQuery';
import { EventsGalleryTemplate } from 'src/modules/events/templates/EventsGalleryTemplate';

export const PastLocalEventsTemplate = () => {
  const { data: events } = usePastLocalEventsListQuery();

  return (
    <EventsGalleryTemplate
      type="past-local"
      hasResults={!!events?.length}
      staticMenu={true}
    >
      {events && events.length > 0 && <EventsGridGallery events={events} />}
    </EventsGalleryTemplate>
  );
};
